@if (!!content) {
  <div id="privacy-security-policy" class="card column lg-six lg-push-three">
    <div class="privacy-security-policy-content" [innerHtml]="content"></div>
    <div class="privacy-security-btn margin-top-20 margin-bottom-10">
      <button ds-button type="button" (click)="back()">Go back</button>
    </div>
  </div>
}
